import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../request";
import { URL } from "../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getPrivilegeList from "./PrivilegeList";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BsFillEyeFill } from "react-icons/bs";
import axios from "axios";

const occupationLabels = {
  1: "Salaried",
  2: "Self Employed",
  3: "Business Owner",
  4: "Freelancer",
  5: "Professional",
};
const genderOptions = {
  1: "Male",
  2: "Female",
  3: "Other",
};

const maritalStatusOptions = {
  1: "Married",
  2: "Unmarried",
};
const useQuery = () => new URLSearchParams(useLocation().search);
const CustomerView = () => {
  const query = useQuery();
  const customer_id = query.get("customer_id");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editSection, setEditSection] = useState(null);
  const [editableData, setEditableData] = useState({});
  const [cibilReport, setCibilReport] = useState("");
  const [showCibilModal, setShowCibilModal] = useState(false);
  const [documents, setDocuments] = useState({});
  const [otherDocuments, setOtherDocuments] = useState([]);
  const [modal, setModal] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);
  const [pendingTypeId, setPendingTypeId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingFiles, setPendingFiles] = useState([]);
  const privilegeList = getPrivilegeList();
  const [showModal, setShowModal] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState("");
  const [zoomLevel, setZoomLevel] = useState(1);
  const [uploadingDoc, setUploadingDoc] = useState(null);
  const handleZoomIn = () => setZoomLevel((prev) => prev + 0.1);
  const handleZoomOut = () => setZoomLevel((prev) => Math.max(0.1, prev - 0.1));
  const handleZoomReset = () => setZoomLevel(1);
  const isImage = selectedDocUrl?.match(/\.(jpeg|jpg|png|gif)$/i);
  const [showSalaryModal, setShowSalaryModal] = useState(false);
  const [salaryDocUrl, setSalaryDocUrl] = useState("");
  const [salaryFileType, setSalaryFileType] = useState("application/pdf");
  const [digilockerAddress, setDigilockerAddress] = useState(null);
  const [eyeModalOpen, setEyeModalOpen] = React.useState(false);
  const [showEyeModal, setShowEyeModal] = useState(false);
  const [eyeData, setEyeData] = useState(null);
  const [aadhaarPhoto, setAadhaarPhoto] = useState(null);
  const [eSignDetails, setESignDetails] = useState(null);
  const [latLongData, setLatLongData] = useState([]);
  const [showLatLongModal, setShowLatLongModal] = useState(false);

  const [locationData, setLocationData] = useState(null);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [loadingLocation, setLoadingLocation] = useState(false);

  const [showJourneyModal, setShowJourneyModal] = useState(false);
  const [journeyData, setJourneyData] = useState(null);
  const [loadingJourney, setLoadingJourney] = useState(false);

  const fetchAppScreen = async () => {
    try {
      setLoadingJourney(true);
      setShowJourneyModal(true);
      const res = await axiosInstance.get(URL.CUSTOMER_LOAN_JOURNEY, {
        params: { customerId: customer_id },
      });
      setJourneyData(res.data);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404) toast.error("Customer not found");
      else if (status === 400) toast.error("Phone number does not match this customer");
      else toast.error("Unable to load app screen");
      setShowJourneyModal(false);
    } finally {
      setLoadingJourney(false);
    }
  };

  const [downloadingStatement, setDownloadingStatement] = useState(false);

  const downloadAccountStatement = async () => {
    try {
      setDownloadingStatement(true);
      const res = await axiosInstance.get(URL.ACCOUNT_STATEMENT_PDF, {
        params: { customerId: customer_id },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Account_Statement_${customer_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download account statement", err);
      toast.error("Unable to download account statement");
    } finally {
      setDownloadingStatement(false);
    }
  };

  const modalEl = document.getElementById("qrDetailsModal");

  const [showPasswordModal, setShowPasswordModal] = useState(false);
const [salaryPassword, setSalaryPassword] = useState("");
const [isSalaryLoading, setIsSalaryLoading] = useState(false);

  const getFileType = (url) => {
    if (!url) return null;
    // This regex extracts the extension even if there are S3 query parameters
    const extension = url
      .split(/[#?]/)[0]
      .split(".")
      .pop()
      .trim()
      .toLowerCase();

    if (extension === "pdf") return "application/pdf";
    if (extension === "png") return "image/png";
    if (extension === "jpg" || extension === "jpeg") return "image/jpeg";
    if (extension === "xlsx" || extension === "xls")
      return "application/vnd.ms-excel";
    return null;
  };

  useEffect(() => {
    const fetchDigilockerAddress = async () => {
      try {
        const res = await axiosInstance.get(URL.DIGILOCKER_ADDRESS, {
          params: { customer_id },
        });

        // Response structure: { "31": { "0O-SFO-532793 update now": { ... } } ss}
        const customerData = res.data?.[customer_id];
        if (customerData) {
          const firstKey = Object.keys(customerData)[0]; // e.g., "0O-SFO-532793345"
          setDigilockerAddress(customerData[firstKey]);
        }
      } catch (err) {
        console.error("Failed to fetch Digilocker address", err);
      }
    };

    if (customer_id) fetchDigilockerAddress();
  }, [customer_id]);

  const fetchCibilReport = async () => {
    try {
      const res = await axiosInstance.get(URL.CIBIL_VIEW, {
        params: { customer_id },
      });
      setCibilReport(res.data);
      setShowCibilModal(true);
    } catch (err) {
      console.error("Failed to fetch CIBIL report", err);
      toast.error("Unable to load CIBIL report");
    }
  };

  useEffect(() => {
    const fetchESignDetails = async () => {
      try {
        const res = await axiosInstance.get(URL.E_SIGN, {
          params: { customerId: customer_id },
        });
        setESignDetails(res.data);
      } catch (err) {
        console.error("Failed to load eSign details", err);
      }
    };

    fetchESignDetails();
  }, []);

  const fetchLatLongData = async () => {
    try {
      const res = await axiosInstance.get(URL.LAT_AND_LONG, {
        params: { customer_id },
      });

      setLatLongData(res.data || []);
      setShowLatLongModal(true);
    } catch (err) {
      console.error("Failed to fetch Lat/Long data", err);
      toast.error("Unable to load location data");
    }
  };

  const fetchDocuments = async () => {
    try {
      const res = await axiosInstance.get(URL.DOCUMENT_GET_ALL, {
        params: { customer_id },
      });

      const allDocsObj = res.data || {};
      const allDocsArray = Object.values(allDocsObj).flat();

      const groupedDocs = {
        salary_slip: [],
        bank_statement: [],
        uploaded_documents: [],
      };

      allDocsArray.forEach((doc) => {
        if (doc.document_type_id === 22) {
          groupedDocs.salary_slip.push(doc);
        } else if (doc.document_type_id === 29) {
          groupedDocs.bank_statement.push(doc);
        } else {
          groupedDocs.uploaded_documents.push(doc);
        }
      });

      setDocuments(groupedDocs);

      // Other Documents (28)
      setOtherDocuments(
        groupedDocs.uploaded_documents.filter((d) => d.document_type_id === 28)
      );
    } catch (err) {
      console.error("Failed to fetch documents", err);
      toast.error("Failed to load documents");
    }
  };

  // For CIBIL / Digilocker / OneMoney
  const openReportModal = async (title, url) => {
    try {
      const res = await axiosInstance.get(url, { params: { customer_id } });
      setModal({
        show: true,
        title,
        contentUrl: "data:text/html," + encodeURIComponent(res.data),
      });
    } catch (err) {
      toast.error(`${title} not present`);
    }
  };

  // For document view
  const openDocumentModal = (title, docUrl) => {
    setModal({
      show: true,
      title,
      contentUrl: docUrl,
    });
  };

  // const fetchCurrentLocation = () => {
  //   if (!navigator.geolocation) {
  //     toast.error("Geolocation is not supported by your browser");
  //     return;
  //   }

  const openOnMap = (lat, long) => {
  const url = `https://www.google.com/maps?q=${lat},${long}`;
  window.open(url, "_blank");
};

const fetchCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        
        try {
          // Optional: If you want to get a readable address, use a reverse geocoding API
          // For now, we will just set the coordinates.
          setLocationData({
            latitude,
            longitude,
            address: "Address lookup feature can be integrated here (e.g., Google Maps API)"
          });
          setShowLocationModal(true);
        } catch (error) {
          console.error("Error fetching address:", error);
          toast.error("Failed to get location address");
        } finally {
          setLoadingLocation(false);
        }
      },
      (error) => {
        setLoadingLocation(false);
        toast.error("Unable to retrieve your location. Please enable location permissions.");
      }
    );
  };

  // const handleFileSelect = (event, documentTypeId) => {
  //   const files = Array.from(event.target.files || []);
  //   if (!files.length) return;

  //   // ✅ Salary Slip (22) & Bank Statement (29) → multiple upload
  //   if (
  //     documentTypeId === SALARY_SLIP_TYPE_ID ||
  //     documentTypeId === BANK_STATEMENT_TYPE_ID
  //   ) {
  //     setPendingFiles(files);
  //   } else {
  //     setPendingFiles([files[0]]);
  //   }

  //   setPendingTypeId(documentTypeId);
  //   setShowConfirmModal(true);
  //   event.target.value = "";
  // };


  const handleFileSelect = (event, documentTypeId) => {
  const files = Array.from(event.target.files || []);
  if (!files.length) return;

  // Set pending state
  if (
    documentTypeId === SALARY_SLIP_TYPE_ID ||
    documentTypeId === BANK_STATEMENT_TYPE_ID
  ) {
    setPendingFiles(files);
  } else {
    setPendingFiles([files[0]]);
  }

  setPendingTypeId(documentTypeId);

  // ✅ New Logic: If Salary Slip, show Password Modal. Otherwise, show Confirm Modal.
  if (documentTypeId === SALARY_SLIP_TYPE_ID) {
    setShowPasswordModal(true); 
  } else {
    setShowConfirmModal(true);
  }

  event.target.value = "";
};

  const SALARY_SLIP_TYPE_ID = 22;
  const BANK_STATEMENT_TYPE_ID = 29;

  // const confirmUpload = async () => {
  //   if (!pendingFiles.length || !pendingTypeId) return;

  //   try {
  //     // ✅ Salary Slip & Bank Statement same logic
  //     if (
  //       pendingTypeId === SALARY_SLIP_TYPE_ID ||
  //       pendingTypeId === BANK_STATEMENT_TYPE_ID
  //     ) {
  //       for (const file of pendingFiles) {
  //         const formData = new FormData();
  //         formData.append("file", file);
  //         formData.append("customer_id", customer_id);
  //         formData.append("documentTypeId", Number(pendingTypeId));

  //         await axiosInstance.post(URL.DOCUMENT_UPLOAD, formData, {
  //           headers: { "Content-Type": "multipart/form-data" },
  //         });
  //       }

  //       toast.success(
  //         pendingTypeId === SALARY_SLIP_TYPE_ID
  //           ? "Salary slips uploaded successfully"
  //           : "Bank statements uploaded successfully"
  //       );
  //     } else {
  //       // 🔁 Other documents (single replace)
  //       await axiosInstance.post(URL.UPDATE_DOCUMENT, {
  //         customer_id: Number(customer_id),
  //         documentTypeId: Number(pendingTypeId),
  //       });

  //       const formData = new FormData();
  //       formData.append("file", pendingFiles[0]);
  //       formData.append("customer_id", customer_id);
  //       formData.append("documentTypeId", Number(pendingTypeId));

  //       await axiosInstance.post(URL.DOCUMENT_UPLOAD, formData, {
  //         headers: { "Content-Type": "multipart/form-data" },
  //       });

  //       toast.success("Document uploaded");
  //     }

  //     await fetchDocuments();
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Upload failed");
  //   } finally {
  //     setPendingFiles([]);
  //     setPendingTypeId(null);
  //     setShowConfirmModal(false);
  //   }
  // };

const confirmUpload = async () => {
    if (!pendingFiles.length || !pendingTypeId) return;

    try {
      if (
        pendingTypeId === SALARY_SLIP_TYPE_ID ||
        pendingTypeId === BANK_STATEMENT_TYPE_ID
      ) {
        for (const file of pendingFiles) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("customer_id", customer_id);
          formData.append("documentTypeId", Number(pendingTypeId));

          // ✅ Add password only for Salary Slips
          if (pendingTypeId === SALARY_SLIP_TYPE_ID && salaryPassword) {
            formData.append("password", salaryPassword);
          }

          await axiosInstance.post(URL.DOCUMENT_UPLOAD, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }

        toast.success(
          pendingTypeId === SALARY_SLIP_TYPE_ID
            ? "Salary slips uploaded successfully"
            : "Bank statements uploaded successfully"
        );
      } else {
        // Other documents logic
        await axiosInstance.post(URL.UPDATE_DOCUMENT, {
          customer_id: Number(customer_id),
          documentTypeId: Number(pendingTypeId),
        });

        const formData = new FormData();
        formData.append("file", pendingFiles[0]);
        formData.append("customer_id", customer_id);
        formData.append("documentTypeId", Number(pendingTypeId));

        await axiosInstance.post(URL.DOCUMENT_UPLOAD, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        toast.success("Document uploaded");
      }

      await fetchDocuments();
    } catch (error) {
      console.error(error);
      toast.error("Upload failed");
    } finally {
      setPendingFiles([]);
      setPendingTypeId(null);
      setSalaryPassword(""); // ✅ Clear password after upload
      setShowConfirmModal(false);
      setShowPasswordModal(false); // ✅ Close password modal
    }
  };

  const handleViewDocument = (docUrl) => {
    setSelectedDocUrl(docUrl);
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      if (editSection === "personal") {
        // Map gender string to number
        if (editableData.gender) {
          const genderMap = { Male: 1, Female: 2, Other: 3 };
          editableData.gender =
            genderMap[editableData.gender] || editableData.gender;
        }

        // Map marital status string to number
        if (editableData.marital_status) {
          const maritalMap = { Married: 1, Unmarried: 2 };
          editableData.marital_status =
            maritalMap[editableData.marital_status] ||
            editableData.marital_status;
        }
      }

      let res;
      switch (editSection) {
        case "personal":
          res = await axiosInstance.post(URL.UPDATE_CUSTOMER_DETAILS, {
            customer_id,
            ...editableData,
          });
          toast.success(res.data.message || "Personal details updated");
          break;

        case "employment":
          res = await axiosInstance.post(URL.UPDATE_EMPLOYMENT_DETAILS, {
            customer_id,
            ...editableData,
          });
          toast.success(res.data.message || "Professional details updated");
          break;

        case "reference":
          res = await axiosInstance.post(URL.UPDATE_REFERENCE_DETAILS, {
            customer_id,
            ...editableData,
          });
          toast.success(res.data.message || "Personal details details updated");
          break;

        case "Current":
        case "Permanent ":
          const addressTypeMap = { Current: 1, Permanent: 2 };
          res = await axiosInstance.post(URL.UPDATE_ADDRESS_DETAILS, {
            customer_id,
            address_type: addressTypeMap[editSection],
            postal_code: editableData.pin_code, // mapping field name
            full_address: editableData.full_address,
            land_mark: editableData.land_mark,
          });
          toast.success(res.data.message || `${editSection} address updated`);
          break;

        case "Bank":
          const currentAcc = data.bankList?.[0]?.account_number;

          res = await axiosInstance.post(URL.UPDATE_BANK_DETAILS, {
            customerId: Number(customer_id),
            accountNumber: Number(currentAcc),
            newAccountNumber: Number(editableData.account_number || currentAcc),
            ifscCode: editableData.ifsc_code || data.bankList?.[0]?.ifsc_code,
          });

          toast.success(res.data.message || "Bank details updated");
          break;

        case "Status":
          if (!editableData.comment) {
            toast.error("Please add a comment before saving status");
            return;
          }

          //   const finalLoanStatus =
          // Number(editableData.customer_status) === 4 ? 4 : Number(editableData.loan_status);

          const userId = localStorage.getItem("userId");
          res = await axiosInstance.post(URL.ALL_STATUS_CHANGE, {
            customer_id,
            customer_status: Number(editableData.customer_status),
            loan_status: Number(editableData.loan_status),
            // loan_status: finalLoanStatus,
            disbursal_status: Number(editableData.disbursal_status),
            comment: editableData.comment,
            comment_by: Number(userId),
          });

          toast.success(res.data.message || "Statuses updated successfully");
          break;

        default:
          return;
      }

      const fresh = await axiosInstance.get(URL.FULL_DETAILS, {
        params: { customer_id },
      });

      const genderMapReverse = { Male: 1, Female: 2, Other: 3 };
      const maritalMapReverse = { Married: 1, Unmarried: 2 };

      if (fresh.data.customerDetails) {
        fresh.data.customerDetails.gender =
          genderMapReverse[fresh.data.customerDetails.gender] ||
          fresh.data.customerDetails.gender;
        fresh.data.customerDetails.marital_status =
          maritalMapReverse[fresh.data.customerDetails.marital_status] ||
          fresh.data.customerDetails.marital_status;
      }

      setData(fresh.data);

      setEditSection(null);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update");
    }
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await axiosInstance.get(URL.FULL_DETAILS, {
          params: { customer_id },
        });
        const d = res.data || {};

        const genderMapReverse = { Male: 1, Female: 2, Other: 3 };
        const maritalMapReverse = { Married: 1, Unmarried: 2 };

        if (d.customerDetails) {
          d.customerDetails.gender =
            genderMapReverse[d.customerDetails.gender] ||
            d.customerDetails.gender;
          d.customerDetails.marital_status =
            maritalMapReverse[d.customerDetails.marital_status] ||
            d.customerDetails.marital_status;
        }

        setData({
          customerDetails: d.customerDetails || {
            full_name: "-NA-",
            father_name: "-NA-",
            phone_number: "-NA-",
            marital_status: "-NA-",
            spouse_name: "-NA-",
            dob: "-NA-",
            gender: "-NA-",
            occupation: "-NA-",
          },
          employmentDetails: d.employmentDetails || {
            company_name: "",
            hr_contact_number: "",
            monthly_income: "",
            company_address: "",
            office_landmark: "",
            office_city_name: "",
            office_state_name: "",
            office_pin_code: "",
          },
          referenceList:
            d.referenceList && d.referenceList.length > 0
              ? d.referenceList
              : [{ reference_type_name: "", full_name: "", phone_number: "" }],
          addressList: d.addressList || [],
          loanList: Array.isArray(d.loanList) ? d.loanList : [],
          bankList: d.bankList || [],
          statuses: d.statuses || {},
        });
        await fetchDocuments();
      } catch (err) {
        console.error("Failed to load details", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [customer_id]);

  if (loading) return <div className="container mt-4">Loading...</div>;
  if (!data)
    return <div className="container mt-4 text-danger">No data found</div>;

  // const { customerDetails, referenceList, employmentDetails, loanList, addressList, bankdetails } = data;

  const {
    customerDetails = {},
    referenceList = [],
    employmentDetails = {},
    loanList = [],
    addressList = [],
    bankdetails = [],
  } = data || {};

  const isEditing = (section) => editSection === section;

  const handleChange = (field, value) => {
    setEditableData({ ...editableData, [field]: value });
  };

  const { statuses = {} } = data || {};

  const isEditDisabled =
    statuses.customerStatus === 3 ||
    statuses.customerStatus === 4 ||
    statuses.loanStatus === 1 ||
    statuses.loanStatus === 3 ||
    statuses.loanStatus === 4 ||
    statuses.disbursalStatus === 3;

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-10">
            <div className="d-flex justify-content-between align-items-center">
              <h3>Customer Profile ({customerDetails.customer_id})</h3>
            </div>
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-end gap-2">
            <button
              className="btn btn-sm btn-light border d-flex align-items-center justify-content-center"
              style={{ width: 44, height: 44, padding: 0, fontSize: 20 }}
              onClick={async () => {
                try {
                  const res = await axiosInstance.get(URL.CUSTOMER_EYE_VIEW, {
                    params: { customer_id: customerDetails.customer_id },
                  });
                  setEyeData(res.data);
                  setShowEyeModal(true);
                } catch (err) {
                  toast.error("Failed to load extra customer data");
                }
              }}
              title="Customer Details"
            >
              <BsFillEyeFill />
            </button>

            {/* Lat & Long Button */}
            <button
              className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
              style={{ width: 44, height: 44, padding: 0, fontSize: 20 }}
              onClick={fetchLatLongData}
              title="Location History"
            >
              <i className="bi bi-geo-alt"></i>
            </button>

            {/* App Screen Button */}
            <button
              className="btn btn-sm btn-info text-white d-flex align-items-center justify-content-center"
              style={{ width: 44, height: 44, padding: 0, fontSize: 20 }}
              onClick={fetchAppScreen}
              title="App Screen"
            >
              <i className="bi bi-phone"></i>
            </button>

            {/* Account Statement PDF Button */}
            <button
              className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
              style={{ width: 44, height: 44, padding: 0, fontSize: 20 }}
              onClick={downloadAccountStatement}
              disabled={downloadingStatement}
              title="Account Statement"
            >
              {downloadingStatement ? (
                <span className="spinner-border spinner-border-sm" role="status" />
              ) : (
                <i className="bi bi-file-earmark-pdf"></i>
              )}
            </button>
          </div>

          {/* Personal Details */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <span>Personal Details</span>
              {!isEditing("personal") ? (
                privilegeList.personalDetailsEdit && (
                  <button
                    className="btn btn-sm btn-warning"
                    disabled={isEditDisabled} // 🔹 disable logic here
                    onClick={() => {
                      if (isEditDisabled) return; // extra safety
                      setEditSection("personal");
                      setEditableData({ ...customerDetails });
                    }}
                  >
                    Edit
                  </button>
                )
              ) : (
                <div>
                  <button
                    className="btn btn-sm btn-success me-2"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => setEditSection(null)}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            <div className="card-body row">
              {/* Name, Father's Name, Mobile, Spouse Name, DOB */}
              {[
                ["full_name", "Name"],
                ["father_name", "Father's Name"],
                ["phone_number", "Mobile"],
                ["spouse_name", "Spouse Name"],
                ["dob", "DOB"],
                ["pan_number", "PAN Number"],
                ["aadhaar_number", "Aadhaar Number"],
                ["loan_amount", "Required Amount"],
                ["email", "E-mail"],
                ["bureau_score", "Bureau Score"],
              ].map(([key, label]) => (
                <div className="col-md-6 mb-2" key={key}>
                  <label>{label}</label>
                  <input
                    className="form-control"
                    value={
                      isEditing("personal")
                        ? editableData[key]
                        : customerDetails[key] || ""
                    }
                    disabled={!isEditing("personal")}
                    onChange={(e) => handleChange(key, e.target.value)}
                  />
                </div>
              ))}

              {/* Marital Status */}
              <div className="col-md-6 mb-2">
                <label>Marital Status</label>
                {isEditing("personal") ? (
                  <select
                    className="form-control"
                    value={editableData.marital_status || ""}
                    onChange={(e) =>
                      handleChange("marital_status", e.target.value)
                    }
                  >
                    <option value="">Select Marital Status</option>
                    {Object.entries(maritalStatusOptions).map(
                      ([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      )
                    )}
                  </select>
                ) : (
                  <input
                    className="form-control"
                    value={
                      maritalStatusOptions[customerDetails.marital_status] || ""
                    }
                    disabled
                  />
                )}
              </div>

              {/* Gender */}
              <div className="col-md-6 mb-2">
                <label>Gender</label>
                {isEditing("personal") ? (
                  <select
                    className="form-control"
                    value={editableData.gender || ""}
                    onChange={(e) => handleChange("gender", e.target.value)}
                  >
                    <option value="">Select Gender</option>
                    {Object.entries(genderOptions).map(([value, label]) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    className="form-control"
                    value={genderOptions[customerDetails.gender] || ""}
                    disabled
                  />
                )}
              </div>

              {/* Occupation */}
              <div className="col-md-6 mb-2">
                <label>Occupation</label>
                {isEditing("personal") ? (
                  <select
                    className="form-control"
                    value={editableData.occupation || ""}
                    onChange={(e) => handleChange("occupation", e.target.value)}
                  >
                    <option value="">Select Occupation</option>
                    {Object.entries(occupationLabels).map(([value, label]) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    className="form-control"
                    value={occupationLabels[customerDetails.occupation] || ""}
                    disabled
                  />
                )}
              </div>
            </div>
          </div>

          {/* Address Section */}
          <>
            {["Current", "Permanent"].map((type) => {
              const address = (addressList &&
                addressList.find((a) => a.address_type === type)) || {
                address_type: type,
                full_address: "",
                land_mark: "",
                city: "",
                state: "",
                pin_code: "",
              };

              const canEdit =
                type === "Current"
                  ? privilegeList.currentAddressEdit
                  : privilegeList.permanenetAddressEdit;

              return (
                <div key={type} className="card mt-3">
                  <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                    <span>{type} Address </span>
                    {!isEditing(type) ? (
                      canEdit && (
                        <button
                          className="btn btn-sm btn-warning"
                          disabled={isEditDisabled} // 🔹 disable logic here
                          onClick={() => {
                            if (isEditDisabled) return;
                            setEditSection(type);
                            setEditableData({ ...address });
                          }}
                        >
                          Edit
                        </button>
                      )
                    ) : (
                      <div>
                        <button
                          className="btn btn-sm btn-success me-2"
                          onClick={handleSave}
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => setEditSection(null)}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="card-body row">
                    {[
                      ["full_address", "Address"],
                      ["land_mark", "Landmark"],
                      ["city", "City"],
                      ["state", "State"],
                      ["pin_code", "Pincode"],
                    ].map(([key, label]) => (
                      <div className="col-md-6 mb-2" key={key}>
                        <label>{label}</label>
                        <input
                          className="form-control"
                          value={
                            isEditing(type)
                              ? editableData[key]
                              : address[key] || ""
                          }
                          disabled={
                            key === "city" ||
                            key === "state" ||
                            !isEditing(type)
                          }
                          onChange={(e) => handleChange(key, e.target.value)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </>
          {/* Digilocker Address Section */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white">
              Digilocker Address
            </div>
            <div className="card-body row">
              {digilockerAddress ? (
                <>
                  <div className="col-md-6 mb-2">
                    <label>Address</label>
                    <input
                      className="form-control"
                      value={digilockerAddress.address || "-NA-"}
                      disabled
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <label>Landmark</label>
                    <input
                      className="form-control"
                      value={digilockerAddress.landmark || "-NA-"}
                      disabled
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label>District</label>
                    <input
                      className="form-control"
                      value={digilockerAddress.district || "-NA-"}
                      disabled
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label>State</label>
                    <input
                      className="form-control"
                      value={digilockerAddress.state || "-NA-"}
                      disabled
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label>Pincode</label>
                    <input
                      className="form-control"
                      value={digilockerAddress.pincode || "-NA-"}
                      disabled
                    />
                  </div>
                </>
              ) : (
                <p className="text-muted">No Digilocker address found</p>
              )}
            </div>
          </div>

          {/* Professional Details */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <span>Professional Details</span>
              {!isEditing("employment") ? (
                privilegeList.professionalDetailsEdit && (
                  <button
                    className="btn btn-sm btn-warning"
                    disabled={isEditDisabled} // 🔹 disable logic here
                    onClick={() => {
                      if (isEditDisabled) return;
                      setEditSection("employment");
                      setEditableData({ ...employmentDetails });
                    }}
                  >
                    Edit
                  </button>
                )
              ) : (
                <div>
                  <button
                    className="btn btn-sm btn-success me-2"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => setEditSection(null)}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            <div className="card-body row">
              {[
                ["company_name", "Company"],
                ["hr_contact_number", "Company Phone"],
                ["monthly_income", "Income"],
                ["company_address", "Company Address"],
                ["office_landmark", "Landmark"],
                ["office_city_name", "City"],
                ["office_state_name", "State"],
                ["office_pin_code", "Pincode"],
                ["employment_type", "Occupation"],
                ["work_email", "Professional E-mail"],
              ].map(([key, label]) => (
                <div className="col-md-6 mb-2" key={key}>
                  <label>{label}</label>
                  <input
                    className="form-control"
                    value={
                      key === "monthly_income"
                        ? `₹${(isEditing("employment")
                            ? editableData[key]
                            : employmentDetails?.[key] || 0
                          ).toLocaleString()}`
                        : isEditing("employment")
                        ? editableData[key]
                        : employmentDetails?.[key] || ""
                    }
                    disabled={
                      key === "office_city_name" ||
                      key === "office_state_name" ||
                      !isEditing("employment")
                    }
                    onChange={(e) => handleChange(key, e.target.value)}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Reference Details */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white">
              Reference Details
            </div>
            <div className="card-body">
              {referenceList &&
                referenceList.length > 0 &&
                referenceList.map((ref, idx) => {
                  const isEditingRef = editSection === `reference-${idx}`;
                  const editableRef = isEditingRef ? editableData : ref;

                  return (
                    <div key={idx} className="mb-3 border p-3 rounded">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>Reference Type {idx + 1}</strong>
                        {!isEditingRef ? (
                          privilegeList.referenceDetailsEdit && (
                            <button
                              className="btn btn-sm btn-warning"
                              disabled={isEditDisabled}
                              onClick={() => {
                                if (isEditDisabled) return;
                                setEditSection(`reference-${idx}`);
                                setEditableData({ ...ref });
                              }}
                            >
                              Edit
                            </button>
                          )
                        ) : (
                          <div>
                            <button
                              className="btn btn-sm btn-success me-2"
                              onClick={async () => {
                                try {
                                  const payload = {
                                    customer_id,
                                    reference_type: idx + 1,
                                    full_name: editableData.full_name,
                                    phone_number: editableData.phone_number,
                                    relationship: Number(
                                      editableData.relationship
                                    ),
                                  };
                                  const res = await axiosInstance.post(
                                    URL.UPDATE_REFERENCE_DETAILS,
                                    payload
                                  );
                                  toast.success(
                                    res.data.message ||
                                      `Reference ${idx + 1} updated`
                                  );
                                  const fresh = await axiosInstance.get(
                                    URL.FULL_DETAILS,
                                    {
                                      params: { customer_id },
                                    }
                                  );
                                  setData(fresh.data);
                                  setEditSection(null);
                                } catch (err) {
                                  console.error(err);
                                  toast.error("Failed to update reference");
                                }
                              }}
                            >
                              Save
                            </button>
                            <button
                              className="btn btn-sm btn-secondary"
                              onClick={() => setEditSection(null)}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="row">
                        {/* Relationship dropdown */}
                        <div className="col-md-4 mb-2">
                          <label>Relationship</label>
                          {isEditingRef ? (
                            <select
                              className="form-control"
                              value={editableRef.relationship}
                              onChange={(e) =>
                                setEditableData((prev) => ({
                                  ...prev,
                                  relationship: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select</option>
                              <option value="1">Family Member</option>
                              <option value="2">Friend</option>
                              <option value="3">Colleague</option>
                              <option value="4">Neighbor</option>
                              <option value="5">Business Partner</option>
                              <option value="6">Other</option>
                            </select>
                          ) : (
                            <input
                              className="form-control"
                              value={
                                {
                                  1: "Family Member",
                                  2: "Friend",
                                  3: "Colleague",
                                  4: "Neighbor",
                                  5: "Business Partner",
                                  6: "Other",
                                }[ref.relationship] || ""
                              }
                              disabled
                            />
                          )}
                        </div>
                        {/* Full Name */}
                        <div className="col-md-4 mb-2">
                          <label>Name</label>
                          <input
                            className="form-control"
                            value={editableRef.full_name || ""}
                            disabled={!isEditingRef}
                            onChange={(e) =>
                              setEditableData((prev) => ({
                                ...prev,
                                full_name: e.target.value,
                              }))
                            }
                          />
                        </div>

                        {/* Phone Number */}
                        <div className="col-md-4 mb-2">
                          <label>Phone Number</label>
                          <input
                            className="form-control"
                            value={editableRef.phone_number || ""}
                            disabled={!isEditingRef}
                            onChange={(e) =>
                              setEditableData((prev) => ({
                                ...prev,
                                phone_number: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {/* Loan History */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white">Loan History</div>
            <div className="card-body table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Loan ID</th>
                    <th>Amount</th>
                    <th>Disbursed Date</th>
                    <th>ROI</th>
                    <th>Tenure</th>
                    <th>Status</th>
                    {privilegeList.loanDetailsView && <th>Action</th>}
                    <th>Agreements</th>
                  </tr>
                </thead>
                <tbody>
                  {loanList?.length > 0 ? (
                    loanList.map((loan) => (
                      <tr key={loan.loan_id}>
                        <td>{loan.loan_id}</td>
                        <td>
                          ₹
                          {loan.loan_amount
                            ? loan.loan_amount.toLocaleString()
                            : "0"}
                        </td>
                        <td>{loan.disbursed_date || ""}</td>
                        <td>{loan.roi ? `${loan.roi}%` : ""}</td>
                        <td>{loan.tenure ? `${loan.tenure} Days` : ""}</td>
                        <td>
                          <span
                            className={`badge ${
                              loan.status_name === "Active"
                                ? "bg-success"
                                : loan.status_name === "Closed"
                                ? "bg-primary"
                                : "bg-secondary"
                            }`}
                          >
                            {loan.status_name || ""}
                          </span>
                        </td>
                        {privilegeList.loanDetailsView && (
                          <td>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() =>
                                (window.location.href = `#/LoanView?loanId=${loan.loan_id}`)
                              }
                            >
                              View
                            </button>
                          </td>
                        )}
                        {/* Agreements Dropdown */}
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-sm btn-outline-dark dropdown-toggle"
                              type="button"
                              id={`dropdownMenuButton-${loan.loan_id}`}
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Agreements
                            </button>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby={`dropdownMenuButton-${loan.loan_id}`}
                            >
                              {/* Loan Agreement */}
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={async () => {
                                    try {
                                      setModal({
                                        show: true,
                                        title: "Loan Agreement",
                                        contentUrl: "",
                                        loading: true,
                                      });

                                      const res = await axiosInstance.get(
                                        URL.LOAN_AGREEMENT,
                                        {
                                          params: { loanId: loan.loan_id },
                                        }
                                      );

                                      setModal({
                                        show: true,
                                        title: "Loan Agreement",
                                        contentUrl: res.data.url, // PDF url
                                        loading: false,
                                      });
                                    } catch (err) {
                                      setModal({
                                        show: false,
                                        title: "",
                                        contentUrl: "",
                                        loading: false,
                                      });
                                      toast.error(
                                        "Failed to load Loan Agreement"
                                      );
                                    }
                                  }}
                                >
                                  Loan Agreement
                                </button>
                              </li>

                              {/* KFS Agreement */}
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={async () => {
                                    try {
                                      setModal({
                                        show: true,
                                        title: "KFS Agreement",
                                        contentUrl: "",
                                        loading: true,
                                      });

                                      const res = await axiosInstance.get(
                                        URL.KFS_AGREEMENT,
                                        {
                                          params: { loanId: loan.loan_id },
                                        }
                                      );

                                      setModal({
                                        show: true,
                                        title: "KFS Agreement",
                                        contentUrl: res.data.url,
                                        loading: false,
                                      });
                                    } catch (err) {
                                      setModal({
                                        show: false,
                                        title: "",
                                        contentUrl: "",
                                        loading: false,
                                      });
                                      toast.error(
                                        "Failed to load KFS Agreement"
                                      );
                                    }
                                  }}
                                >
                                  KFS Agreement
                                </button>
                              </li>

                              {/* NOC Certificate */}
                              <li>
                                <button
                                  className="dropdown-item"
                                  onClick={async () => {
                                    try {
                                      setModal({
                                        show: true,
                                        title: "NOC Certificate",
                                        contentUrl: "",
                                        loading: true,
                                      });

                                      const res = await axiosInstance.get(
                                        URL.NOC_GENERATE,
                                        {
                                          params: { loanId: loan.loan_id },
                                        }
                                      );

                                      setModal({
                                        show: true,
                                        title: "NOC Certificate",
                                        contentUrl: res.data.url,
                                        loading: false,
                                      });
                                    } catch (err) {
                                      setModal({
                                        show: false,
                                        title: "",
                                        contentUrl: "",
                                        loading: false,
                                      });

                                      if (err?.response?.data?.message) {
                                        toast.error(err.response.data.message); // show backend reason (loan not closed, etc.)
                                      } else {
                                        toast.error("Failed to load NOC");
                                      }
                                    }
                                  }}
                                >
                                  NOC Certificate
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-muted">
                        No Loan History Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Lat & Long Modal */}
          {/* {showLatLongModal && (
  <div
    className="modal fade show"
    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header bg-dark text-white">
          <h5 className="modal-title">Device Lat & Long Info</h5>
          <button
            className="btn-close"
            onClick={() => setShowLatLongModal(false)}
          ></button>
        </div>

        <div className="modal-body">
          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr>
                <th>Device Name</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>IP Address</th>
                <th>Create Date</th>
              </tr>
            </thead>
            <tbody>
              {latLongData.length > 0 ? (
                latLongData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.device_name}</td>
                    <td>{item.latitude}</td>
                    <td>{item.longitude}</td>
                    <td>{item.ip_address}</td>
                    <td>{item.create_date?.split("T")[0]}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowLatLongModal(false)}
          >
            Close
          </button>
        </div>

      </div>
    </div>
  </div>
)} */}

          {showLatLongModal && (
  <div
    className="modal fade show"
    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header bg-dark text-white">
          <h5 className="modal-title">Customer Device Location History</h5>
          <button
            className="btn-close btn-close-white"
            onClick={() => setShowLatLongModal(false)}
          />
        </div>

        <div className="modal-body">
          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr>
                <th>Device Name</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>IP Address</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {latLongData.length > 0 ? (
                latLongData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.device_name}</td>
                    <td>{item.latitude}</td>
                    <td>{item.longitude}</td>
                    <td>{item.ip_address}</td>
                    <td>{item.create_date?.split("T")[0]}</td>
                    <td>
                      {/* ✅ This button correctly opens the customer's location */}
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => openOnMap(item.latitude, item.longitude)}
                      >
                        View on Map
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No location records found for this customer.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowLatLongModal(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}

          {/* App Screen / Loan Journey Modal */}
          {showJourneyModal && (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ borderRadius: "12px", overflow: "hidden", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}>
                  <div
                    className="modal-header"
                    style={{
                      background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                      color: "#fff",
                      borderBottom: "none",
                    }}
                  >
                    <h5 className="modal-title fw-bold">
                      <i className="bi bi-phone me-2"></i>Customer App Screen
                    </h5>
                    <button
                      className="btn-close btn-close-white"
                      onClick={() => { setShowJourneyModal(false); setJourneyData(null); }}
                    />
                  </div>

                  <div className="modal-body p-4">
                    {loadingJourney && (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status" />
                        <p className="mt-2 text-muted mb-0">Loading journey...</p>
                      </div>
                    )}

                    {!loadingJourney && journeyData && (
                      <>
                        <div className="d-flex align-items-center mb-3">
                          <div
                            style={{
                              width: 56,
                              height: 56,
                              borderRadius: "50%",
                              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 22,
                              fontWeight: "bold",
                              flexShrink: 0,
                            }}
                          >
                            {journeyData.customerName?.charAt(0)?.toUpperCase() || "?"}
                          </div>
                          <div className="ms-3">
                            <h6 className="mb-0 fw-bold">{journeyData.customerName || "-"}</h6>
                            <small className="text-muted">
                              ID: {journeyData.customerId} &middot; {journeyData.phoneNumber || "-"}
                            </small>
                          </div>
                        </div>

                        <hr />

                        {journeyData.stepId == null ? (
                          <div className="text-center py-3">
                            <i className="bi bi-info-circle text-secondary" style={{ fontSize: 36 }}></i>
                            <p className="mt-2 mb-0 text-muted">
                              {journeyData.message || "Journey not started yet"}
                            </p>
                          </div>
                        ) : (
                          <div className="row g-3">
                            <div className="col-12">
                              <div
                                className="p-3"
                                style={{
                                  background: "#f8f9fc",
                                  borderRadius: 10,
                                  border: "1px solid #e3e6f0",
                                }}
                              >
                                <small className="text-muted d-block mb-1">Current Step</small>
                                <span className="fw-bold" style={{ fontSize: 16 }}>
                                  {journeyData.stepTitle || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-12">
                              <div
                                className="p-3 text-center"
                                style={{
                                  background: "#f8f9fc",
                                  borderRadius: 10,
                                  border: "1px solid #e3e6f0",
                                }}
                              >
                                <small className="text-muted d-block">Screen</small>
                                <strong style={{ fontSize: 14 }}>{journeyData.screen || "-"}</strong>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div className="modal-footer" style={{ borderTop: "1px solid #e3e6f0" }}>
                    <button
                      className="btn btn-secondary"
                      onClick={() => { setShowJourneyModal(false); setJourneyData(null); }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/*location */}

          {showLocationModal && locationData && (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header bg-dark text-white">
                    <h5 className="modal-title">Current Location</h5>
                    <button
                      className="btn-close"
                      onClick={() => setShowLocationModal(false)}
                    />
                  </div>

                  <div className="modal-body">
                    <p>
                      <strong>Latitude:</strong> {locationData.latitude}
                    </p>
                    <p>
                      <strong>Longitude:</strong> {locationData.longitude}
                    </p>
                    <p>
                      <strong>Address:</strong>
                    </p>
                    <p className="text-muted">{locationData.address}</p>

                    <a
                      href={`https://www.google.com/maps?q=${locationData.latitude},${locationData.longitude}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm mt-2"
                    >
                      View on Map
                    </a>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowLocationModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* E-Sign Details Section */}
          {eSignDetails && (
            <div className="card mt-3">
              <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <span>E-Sign Details</span>
              </div>

              <div className="card-body row">
                {[
                  ["name", "Name"],
                  ["phoneNumber", "Phone Number"],
                  ["agreementSend", "Agreement Sent"],
                  ["deviceUsed", "Device Used"],
                  ["ipAddress", "IP Address"],
                  ["eSignDate", "E-Sign Date"],
                  ["updateDate", "Update Date"],
                  ["message", "Message"],
                ].map(([key, label]) => (
                  <div className="col-md-6 mb-2" key={key}>
                    <label className="fw-bold">{label}</label>
                    <div className="form-control bg-light">
                      {key === "agreementSend"
                        ? eSignDetails[key] === 1
                          ? "Yes"
                          : "No"
                        : eSignDetails[key] || "-"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Bank Details  */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <span>Bank Details</span>
              {!isEditing("Bank") ? (
                privilegeList.bankDetailsEdit && (
                  <button
                    className="btn btn-sm btn-warning"
                    disabled={isEditDisabled} // 🔹 disable logic here
                    onClick={() => {
                      if (isEditDisabled) return;
                      const defaultBank =
                        (data.bankList && data.bankList[0]) || {};
                      setEditableData({
                        account_number: defaultBank.account_number || "",
                        ifsc_code: defaultBank.ifsc_code || "",
                        bank_name: defaultBank.bank_name || "",
                      });
                      setEditSection("Bank");
                    }}
                  >
                    Edit
                  </button>
                )
              ) : (
                <div>
                  <button
                    className="btn btn-sm btn-success me-2"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => setEditSection(null)}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            <div className="card-body row">
              <div className="col-md-6 mb-2">
                <label>Account No.</label>
                <input
                  className="form-control"
                  value={
                    isEditing("Bank")
                      ? editableData.account_number || ""
                      : (data.bankList && data.bankList[0]?.account_number) ||
                        "-NA-"
                  }
                  onChange={(e) =>
                    setEditableData((prev) => ({
                      ...prev,
                      account_number: e.target.value,
                    }))
                  }
                  disabled={!isEditing("Bank")}
                />
              </div>
              <div className="col-md-6 mb-2">
                <label>IFSC Code</label>
                <input
                  className="form-control"
                  value={
                    isEditing("Bank")
                      ? editableData.ifsc_code || ""
                      : (data.bankList && data.bankList[0]?.ifsc_code) || "-NA-"
                  }
                  onChange={(e) =>
                    setEditableData((prev) => ({
                      ...prev,
                      ifsc_code: e.target.value,
                    }))
                  }
                  disabled={!isEditing("Bank")}
                />
              </div>
              <div className="col-md-6 mb-2">
                <label>Bank Name</label>
                <input
                  className="form-control"
                  value={
                    isEditing("Bank")
                      ? editableData.bank_name || ""
                      : (data.bankList && data.bankList[0]?.bank_name) || "-NA-"
                  }
                  onChange={(e) =>
                    setEditableData((prev) => ({
                      ...prev,
                      bank_name: e.target.value,
                    }))
                  }
                  disabled
                />
              </div>
            </div>
          </div>

          {privilegeList.statusEdit && (
            <div className="card mt-3">
              <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <span>Status Management</span>
                {!isEditing("Status") ? (
                  privilegeList.statusEdit && (
                    <button
                      className="btn btn-sm btn-warning"
                      onClick={() => {
                        setEditableData({
                          customer_status:
                            data.customerDetails?.customer_status || "",
                          comment: "",
                        });
                        setEditSection("Status");
                      }}
                    >
                      Edit
                    </button>
                  )
                ) : (
                  <div>
                    <button
                      className="btn btn-sm btn-success me-2"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => setEditSection(null)}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>

              <div className="card-body row">
                <div className="col-md-6 mb-2">
                  <label>Customer Status</label>
                  <select
                    className="form-control"
                    value={
                      isEditing("Status")
                        ? editableData.customer_status || ""
                        : data.customerDetails?.customer_status || "-NA-"
                    }
                    onChange={(e) =>
                      setEditableData((prev) => ({
                        ...prev,
                        customer_status: e.target.value,
                      }))
                    }
                    disabled={!isEditing("Status")}
                  >
                    <option value="">Select</option>
                    <option value="1">Pending</option>
                    <option value="2">Under Review</option>
                    <option value="3">Approved</option>
                    <option value="4">Reject</option>
                  </select>
                </div>

                <div className="col-md-12 mb-2">
                  <label>Comment</label>
                  <textarea
                    className="form-control"
                    value={
                      isEditing("Status") ? editableData.comment || "" : "-"
                    }
                    onChange={(e) =>
                      setEditableData((prev) => ({
                        ...prev,
                        comment: e.target.value,
                      }))
                    }
                    disabled={!isEditing("Status")}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Document upload Section */}

          <div className="card mt-3 mb-5">
            <div className="card-header bg-dark text-white">
              Uploaded Documents
            </div>
            <div className="card-body">
              {Object.keys(documents).length > 0 ? (
                <ul className="list-group">
                  {Object.entries(documents).flatMap(([category, docs]) =>
                    docs
                      .filter(
                        (doc) =>
                          doc.document_type_id !== 28 && // exclude Other Documents
                          doc.document_type_id !== 22 &&
                          doc.document_type_id !== 29 // exclude Salary Slips
                      )
                      .map((doc, index) => (
                        <li
                          key={`${category}-${index}`}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <span>{doc.document_name || category}</span>
                          <div>
                            {privilegeList.customerDocumentsView && (
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() =>
                                  handleViewDocument(doc.document_url)
                                }
                              >
                                View
                              </button>
                            )}
                            <label className="btn btn-sm btn-success mb-0">
                              Upload
                              <input
                                type="file"
                                hidden
                                onChange={(e) =>
                                  handleFileSelect(e, doc.document_type_id)
                                }
                              />
                            </label>
                          </div>
                        </li>
                      ))
                  )}
                </ul>
              ) : (
                <p className="text-muted">No documents uploaded</p>
              )}
            </div>
          </div>

          {/* Bank Statement Section */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <span>Bank Statements</span>

              {/* ✅ SAME like Upload Salary Slip */}
              <label className="btn btn-sm btn-success mb-0">
                Upload Bank Statements
                <input
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => handleFileSelect(e, BANK_STATEMENT_TYPE_ID)}
                />
              </label>
            </div>

            <div className="card-body">
              {documents?.bank_statement &&
              documents.bank_statement.length > 0 ? (
                <ul className="list-group">
                  {documents.bank_statement.map((doc, index) => (
                    <li
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>{`Bank Statement ${index + 1}`}</span>

                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => handleViewDocument(doc.document_url)}
                      >
                        View
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted text-center">
                  No bank statements uploaded
                </p>
              )}
            </div>
          </div>

          {/* Salary Slip Section */}
          {/* <div className="card mt-3">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <span>Salary Slips</span>
              {privilegeList.uploadSalarySlip && (
                <label className="btn btn-sm btn-success mb-0">
                  Upload Salary Slips
                  <input
                    type="file"
                    hidden
                    multiple
                    onChange={(e) => handleFileSelect(e, SALARY_SLIP_TYPE_ID)}
                  />
                </label>
              )}
            </div>

            <div className="card-body">
              {documents?.salary_slip && documents.salary_slip.length > 0 ? (
                <ul className="list-group">
                  {documents.salary_slip.map((doc, index) => (
                    <li
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>
                        {doc.salary_slip_month
                          ? `Salary Slip (${doc.salary_slip_month})`
                          : `Salary Slip ${index + 1}`}
                      </span>
                      <div> */}
                      <div className="card mt-3">
  <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
    <span>Salary Slips</span>
    {/* ✅ Upload salary slips (multiple allowed) */}
    {privilegeList.uploadSalarySlip && (
      <label className="btn btn-sm btn-success mb-0">
        Upload Salary Slips
        <input
          type="file"
          hidden
          multiple
          onChange={(e) => handleFileSelect(e, SALARY_SLIP_TYPE_ID)}
        />
      </label>
    )}
  </div>

  <div className="card-body">
    {documents?.salary_slip && documents.salary_slip.length > 0 ? (
      <ul className="list-group">
        {documents.salary_slip.map((doc, index) => (
          <li
            key={index}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <div>
              <div className="fw-bold text-dark">
                {doc.salary_slip_month
                  ? `Salary Slip (${doc.salary_slip_month})`
                  : `Salary Slip ${index + 1}`}
              </div>
              
              {/* ✅ SHOW PASSWORD JUST DOWN OF SALARY SLIP */}
              {doc.password && (
                <div className="text-danger small mt-1" style={{ fontSize: "0.85rem" }}>
                  <i className="bi bi-shield-lock-fill me-1"></i>
                  Password: <strong>{doc.password}</strong>
                </div>
              )}
            </div>

            <div>
                        {/* ✅ View Salary Slip */}
                        {/* {privilegeList.customerDocumentsView && (
                          <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() => {
                              const ext = doc.document_url
                                .split(".")
                                .pop()
                                .toLowerCase();
                              let type = "application/pdf";
                              if (
                                ["jpg", "jpeg", "png", "gif", "bmp"].includes(
                                  ext
                                )
                              ) {
                                type = "image/png";
                              }
                              setSalaryDocUrl(doc.document_url);
                              setSalaryFileType(type);
                              setShowSalaryModal(true);
                            }}
                          >
                            View
                          </button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="text-center">
                  <p className="text-muted">No salary slips uploaded</p>
                </div>
              )}
            </div>
          </div> */}

          {privilegeList.customerDocumentsView && (
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => {
                    const ext = doc.document_url
                      .split(".")
                      .pop()
                      .toLowerCase();
                    let type = "application/pdf";
                    if (["jpg", "jpeg", "png", "gif", "bmp"].includes(ext)) {
                      type = "image/png";
                    }
                    setSalaryDocUrl(doc.document_url);
                    setSalaryFileType(type);
                    setShowSalaryModal(true);
                  }}
                >
                  View
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <div className="text-center">
        <p className="text-muted">No salary slips uploaded</p>
      </div>
    )}
  </div>
</div>


{/* Password Entry Modal */}
{showPasswordModal && (
  <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header bg-primary text-white">
          <h5 className="modal-title">Enter PDF Password</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowPasswordModal(false)} />
        </div>
        <div className="modal-body">
          <label className="mb-2">Enter password for Salary Slip (leave blank if none):</label>
          <input
            type="text"
            className="form-control"
            placeholder="PDF Password"
            value={salaryPassword}
            onChange={(e) => setSalaryPassword(e.target.value)}
          />
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowPasswordModal(false)}>Cancel</button>
          <button className="btn btn-primary" onClick={confirmUpload}>Confirm & Upload</button>
        </div>
      </div>
    </div>
  </div>
)}

          {/* eyeee */}

          {showEyeModal && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => setShowEyeModal(false)}
            >
              <div
                className="modal-dialog modal-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Aadhaar Preview</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowEyeModal(false)}
                    />
                  </div>
                  <div className="modal-body d-flex justify-content-center">
                    {eyeData ? (
                      <div
                        style={{
                          width: "700px",
                          height: "300px",
                          position: "relative",
                          backgroundImage: `url(${require("../assets/images/goverment1.jpg")})`,
                          backgroundSize: "100% 100%",
                          backgroundRepeat: "no-repeat",
                          border: "1px solid #000",
                        }}
                      >
                        {/* === PHOTO (Base64) === */}
                        {eyeData.photo && (
                          <img
                            src={`data:image/jpeg;base64,${eyeData.photo}`}
                            alt="User"
                            style={{
                              position: "absolute",
                              top: "95px",
                              left: "35px",
                              width: "95px",
                              height: "110px",
                              border: "1px solid #000",
                              objectFit: "cover",
                            }}
                          />
                        )}

                        {/* === NAME === */}
                        <div
                          style={{
                            position: "absolute",
                            top: "95px",
                            left: "150px",
                            fontWeight: "bold",
                          }}
                        >
                          {eyeData.name}
                        </div>

                        {/* === DOB === */}
                        <div
                          style={{
                            position: "absolute",
                            top: "120px",
                            left: "150px",
                          }}
                        >
                          <b>DOB:</b> {eyeData.dob}
                        </div>

                        {/* === GENDER === */}
                        <div
                          style={{
                            position: "absolute",
                            top: "145px",
                            left: "150px",
                          }}
                        >
                          {eyeData.gender}
                        </div>

                        {/* === AADHAAR NUMBER LEFT === */}
                        <div
                          style={{
                            position: "absolute",
                            bottom: "55px",
                            left: "60px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {eyeData.uid}
                        </div>

                        {/* === AADHAAR NUMBER RIGHT === */}
                        <div
                          style={{
                            position: "absolute",
                            bottom: "55px",
                            right: "60px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {eyeData.uid}
                        </div>

                        {/* === ADDRESS BLOCK === */}
                        <div
                          style={{
                            position: "absolute",
                            top: "95px",
                            left: "420px",
                            width: "40%",
                            lineHeight: "1.4",
                            fontSize: "14px",
                          }}
                        >
                          <b>Address:</b>
                          <br />
                          {eyeData.address || "-NA-"}
                        </div>

                        {/* === FATHER NAME === */}
                        <div
                          style={{
                            position: "absolute",
                            top: "170px",
                            left: "420px",
                          }}
                        >
                          S/O: {eyeData.father_name || "-NA-"}
                        </div>
                      </div>
                    ) : (
                      <p>No Aadhaar data available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {showSalaryModal && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => setShowSalaryModal(false)}
            >
              <div
                className="modal-dialog modal-xl"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Salary Slip Viewer</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowSalaryModal(false)}
                    />
                  </div>
                  <div className="modal-body" style={{ height: "80vh" }}>
                    {salaryDocUrl ? (
                      <object
                        data={salaryDocUrl}
                        type={salaryFileType}
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      <p>No Salary Slip available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* other documents*/}

          <div className="card mt-3 mb-5">
            <div className="card-header bg-secondary text-white">
              Other Documents
            </div>
            <div className="card-body">
              {otherDocuments.length > 0 ? (
                <ul className="list-group">
                  {otherDocuments.map((doc, index) => (
                    <li
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>{doc.document_name || "Old Document"}</span>
                      {privilegeList.customerDocumentsView && (
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleViewDocument(doc.document_url)}
                        >
                          View
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted">No other documents available</p>
              )}
            </div>
          </div>

          {/* Third Party Report Section */}
          <div className="card mt-3">
            <div className="card-header bg-dark text-white">
              Third Party Report
            </div>
            <div className="card-body">
              {/* CIBIL Report row */}
              <div className="d-flex justify-content-between align-items-center border p-2 rounded mb-2">
                <span>CIBIL Report</span>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={async () => {
                    try {
                      // Show modal immediately with loading
                      setModal({
                        show: true,
                        title: "CIBIL Report",
                        contentUrl: "",
                        loading: true,
                      });

                      const res = await axiosInstance.get(URL.CIBIL_VIEW, {
                        params: { customer_id },
                      });

                      if (res.data?.url) {
                        setModal({
                          show: true,
                          title: "CIBIL Report",
                          contentUrl: res.data.url,
                          loading: false,
                        });
                      } else {
                        setModal({
                          show: false,
                          title: "",
                          contentUrl: "",
                          loading: false,
                        });
                        toast.error("No CIBIL report available");
                      }
                    } catch (err) {
                      console.error(err);
                      setModal({
                        show: false,
                        title: "",
                        contentUrl: "",
                        loading: false,
                      });
                      toast.error("Failed to load CIBIL report");
                    }
                  }}
                >
                  View
                </button>
              </div>

              {/* Modal */}
              {modal.show && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                  onClick={() => setModal({ ...modal, show: false })}
                >
                  <div
                    className="modal-dialog modal-xl"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">{modal.title}</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setModal({ ...modal, show: false })}
                        />
                      </div>
                      <div className="modal-body" style={{ height: "80vh" }}>
                        {modal.loading ? (
                          <div className="d-flex justify-content-center align-items-center h-100">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : modal.contentUrl ? (
                          <object
                            data={modal.contentUrl}
                            type="application/pdf"
                            width="100%"
                            height="100%"
                          />
                        ) : (
                          <p>No document available</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* OneMoney Report row */}
              <div className="d-flex justify-content-between align-items-center border p-2 rounded mb-2">
                <span>OneMoney Report</span>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={async () => {
                    try {
                      const res = await axiosInstance.get(URL.ONEMONEY_VIEW, {
                        params: { customer_id },
                      });
                      setSelectedDocUrl(
                        "data:text/html," + encodeURIComponent(res.data)
                      );
                      setShowModal(true);
                    } catch (err) {
                      console.error(err);
                      toast.error("OneMoney report not present");
                    }
                  }}
                >
                  View
                </button>
              </div>

              {/* OneMoney Excel Report row */}
              <div className="d-flex justify-content-between align-items-center border p-2 rounded mb-2">
                <span>OneMoney Excel</span>

                <button
                  className="btn btn-sm btn-success"
                  onClick={async () => {
                    try {
                      const url = `https://app.peday.money/app/onemoney/excel/${customer_id}`;

                      const res = await axios.get(url, {
                        responseType: "blob",
                      });

                      // Create file link
                      const blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel",
                      });
                      const downloadUrl = window.URL.createObjectURL(blob);
                      const link = document.createElement("a");
                      link.href = downloadUrl;
                      link.download = `OneMoney_Report_${customer_id}.xlsx`;
                      link.click();
                      window.URL.revokeObjectURL(downloadUrl);

                      toast.success("Excel downloaded successfully");
                    } catch (error) {
                      console.error(error);
                      toast.error("Excel report not available");
                    }
                  }}
                >
                  Download
                </button>
              </div>

              {/* <div className="d-flex justify-content-between align-items-center border p-2 rounded mb-2">
  <span>QR Code</span>

  <button
    className="btn btn-sm btn-info"
    onClick={async () => {
      try {
        const res = await axiosInstance.get(URL.GET_QR_CODE, {
          params: { customerId: customer_id },
          responseType: "blob", // 🔥 IMPORTANT
        });

        // Create blob download
        const blob = new Blob([res.data], { type: "image/png" });
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `QR_${customer_id}.png`;
        link.click();

        window.URL.revokeObjectURL(downloadUrl);

        toast.success("QR code downloaded successfully");
      } catch (error) {
        console.error(error);
        toast.error("QR code is not generated for this customer, generate first");
      }
    }}
  >
    Download
  </button>
</div> */}

              {/* QR Code row */}
              <div className="border p-2 rounded mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <span>QR Code</span>

                  <div>
                    {/* QR Details Button */}
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#qrDetailsModal"
                      onClick={async () => {
                        try {
                          const res = await axiosInstance.get(
                            URL.GET_QR_DETAILS,
                            {
                              params: { customerId: customer_id },
                            }
                          );

                          if (!res.data || !res.data.imageUrl) {
                            toast.error("QR code data is missing");
                            return;
                          }

                          // store globally
                          window._qrDetails = res.data;

                          // Fill modal content
                          const modalBody =
                            document.getElementById("qrDetailsModalBody");
                          modalBody.innerHTML = `
              <div class="text-center">
                <img src="${window._qrDetails.imageUrl}" alt="QR Code" style="width:150px; height:150px;" class="mb-2" />
                <div class="small text-start">
                  <div><b>Customer ID:</b> ${window._qrDetails.customerId}</div>
                  <div><b>Status:</b> ${window._qrDetails.status}</div>
                  <div><b>Image URL:</b> <a href="${window._qrDetails.imageUrl}" target="_blank">View Link</a></div>
                </div>
              </div>
            `;

                          toast.success("QR details loaded");
                        } catch (error) {
                          console.error(error);
                          toast.error(
                            "QR code is not generated for this customer, generate first"
                          );
                        }
                      }}
                    >
                      QR Details
                    </button>

                    {/* Download PDF Button */}
                    <button
                      className="btn btn-sm btn-info"
                      onClick={async () => {
                        try {
                          const res = await axiosInstance.get(URL.GET_QR_CODE, {
                            params: { customerId: customer_id },
                            responseType: "blob",
                          });

                          const blob = new Blob([res.data], {
                            type: "application/pdf",
                          });
                          const downloadUrl = window.URL.createObjectURL(blob);

                          const link = document.createElement("a");
                          link.href = downloadUrl;
                          link.download = `QR_${customer_id}.pdf`;
                          document.body.appendChild(link);
                          link.click();
                          link.remove();
                          window.URL.revokeObjectURL(downloadUrl);

                          toast.success("QR PDF downloaded successfully");
                        } catch (error) {
                          console.error(error);
                          toast.error(
                            "QR code is not generated for this customer, generate first"
                          );
                        }
                      }}
                    >
                      Download PDF
                    </button>
                  </div>
                </div>
              </div>

              {/* Modal (always in DOM) */}
              <div
                className="modal fade"
                id="qrDetailsModal"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-sm modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header py-2">
                      <h6 className="modal-title">QR Details</h6>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>

                    <div className="modal-body" id="qrDetailsModalBody">
                      {/* Only text info will be filled dynamically */}
                    </div>

                    <div className="modal-footer py-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Save OneMoney Report row */}
              <div className="d-flex justify-content-between align-items-center border p-2 rounded mb-2">
                <span>Save OneMoney Data</span>

                <button
                  className="btn btn-sm btn-warning"
                  onClick={async () => {
                    try {
                      const res = await axiosInstance.post(
                        URL.SAVE_ONEMONEY,
                        {},
                        { params: { customer_id } } // ⭐ auto uses page customer_id
                      );

                      toast.success(res.data || "OneMoney saved successfully");
                    } catch (err) {
                      console.error(err);
                      toast.error(
                        "Failed to save OneMoney report because S3 data not found"
                      );
                    }
                  }}
                >
                  Save
                </button>
              </div>

              {/* Digilocker Report row */}
              <div className="d-flex justify-content-between align-items-center border p-2 rounded">
                <span>Digilocker Report</span>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={async () => {
                    try {
                      const res = await axiosInstance.get(URL.DIGILOCKER_VIEW, {
                        params: { customer_id },
                      });
                      setSelectedDocUrl(
                        "data:text/html," + encodeURIComponent(res.data)
                      );
                      setShowModal(true);
                    } catch (err) {
                      console.error(err);
                      toast.error("Digilocker report not present");
                    }
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>

          {/* laon & kfs */}

          {modal.show && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => setModal({ ...modal, show: false })}
            >
              <div
                className="modal-dialog modal-xl"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{modal.title}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setModal({ ...modal, show: false })}
                    />
                  </div>
                  <div className="modal-body" style={{ height: "80vh" }}>
                    {modal.loading ? (
                      <div className="d-flex justify-content-center align-items-center h-100">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : modal.contentUrl ? (
                      <object
                        data={modal.contentUrl}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      <p>No document available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* pop to show are you sure  */}

          {showConfirmModal && (
            <div
              className="modal fade show"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)", // dim background
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div
                  className="modal-content"
                  style={{ backgroundColor: "#fff" }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Upload</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowConfirmModal(false)}
                    />
                  </div>
                  <div className="modal-body text-center">
                    <p>Are you sure you want to upload this document?</p>
                    {pendingFile && (
                      <p className="text-muted small">{pendingFile.name}</p>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-primary" onClick={confirmUpload}>
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Modal to view document */}
          {showModal && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => setShowModal(false)}
            >
              <div
                className="modal-dialog modal-lg"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">View Document</h5>
                    <div>
                      <button
                        className="btn btn-sm btn-outline-secondary me-1"
                        onClick={handleZoomOut}
                      >
                        -
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary me-1"
                        onClick={handleZoomIn}
                      >
                        +
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary me-3"
                        onClick={handleZoomReset}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                      ></button>
                    </div>
                  </div>
                  <div
                    className="modal-body sefies"
                    style={{ overflow: "auto" }}
                  >
                    {selectedDocUrl ? (
                      <div style={{ overflow: "auto", height: "80vh" }}>
                        {getFileType(selectedDocUrl) ===
                        "application/vnd.ms-excel" ? (
                          <div className="h-100 d-flex flex-column">
                            {/* The Viewer */}
                            <iframe
                              src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                                selectedDocUrl
                              )}`}
                              width="100%"
                              height="90%"
                              frameBorder="0"
                              title="Excel Viewer"
                            ></iframe>
                            {/* Fallback button if the iframe shows an error */}
                            <div className="text-center p-2 mt-auto">
                              <p className="small text-muted mb-1">
                                Preview not loading? The file might be private.
                              </p>
                              <a
                                href={selectedDocUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-success"
                              >
                                Download Excel File to View
                              </a>
                            </div>
                          </div>
                        ) : getFileType(selectedDocUrl) ===
                          "application/pdf" ? (
                          <object
                            data={selectedDocUrl}
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            style={{
                              transform: `scale(${zoomLevel})`,
                              transformOrigin: "top left",
                              width: `${100 / zoomLevel}%`,
                              height: `${100 / zoomLevel}%`,
                            }}
                          >
                            <p>
                              Your browser does not support PDFs.{" "}
                              <a href={selectedDocUrl}>Download PDF</a>.
                            </p>
                          </object>
                        ) : (
                          <object
                            data={selectedDocUrl}
                            type={getFileType(selectedDocUrl)}
                            width="100%"
                            height="100%"
                            style={{
                              transform: `scale(${zoomLevel})`,
                              transformOrigin: "top left",
                              width: `${100 / zoomLevel}%`,
                              height: `${100 / zoomLevel}%`,
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      <p>No document selected</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
